import React, { memo, useMemo } from 'react';
import {
  mergeClasses,
} from '@fluentui/react-components';
import {
  SectionTilesGrid,
  AIPromptExamples as prompts
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { useExplorePromptsStyles } from './style';

export const ExplorePrompts = memo((props) => {
  const {
    i18n,
    setPrompt,
    MultiLineEllipsisText,
    scrollContainer,
    logger,
  } = props;

  const explorePromptsStyles = useExplorePromptsStyles();
  const onRenderCell = ({ item }) => {
    const {
      promptText,
      imageSrc,
    } = item;

    const localizedPromptText = i18n.getString(promptText);

    const onClick = (event) => {
      if (logger && logger.logTrace) {
        logger.logTrace('AIgeneratedImage: example prompt images clicked', { promptText: localizedPromptText });
      }
      event.preventDefault();
      setPrompt(localizedPromptText);
    };

    // TODO: on key down not working
    const onKeyDown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        setPrompt(localizedPromptText);
      }
    };

    return (
      <div
        className="image-with-prompt"
        role="button"
        onClick={onClick}
        onKeyDown={onKeyDown}
        tabIndex={0}
      >
        <img
          src={imageSrc}
          alt={localizedPromptText}
        />
        <div className="prompt-overlay">
          <MultiLineEllipsisText
            className="example-prompt-template"
            key={`${Math.random()}`} // Force re-render
            text={localizedPromptText}
          />
        </div>
      </div>
    );
  };

  const promptsWithAction = prompts.map(prompt => ({
    ...prompt,
    tabIndex: -1,
    onAction: (event) => {
      if (event) {
        event.preventDefault();
      }
      setPrompt(i18n.getString(prompt.promptText));
    },
  }));

  const promptsGridSection = useMemo(() => ({
    sectionName: 'Prompts',
    sectionClassName: 'prompts-with-image-section',
    itemKey: 'id',
    items: promptsWithAction,
    totalItemCount: promptsWithAction.length,
    config: {
      width: 216,
      height: 184,
      gridMode: true,
      columnPadding: 12,
      rowPadding: 12,
      scrollContainer: scrollContainer !== undefined ? scrollContainer : '[role="main"]',
    },
  }), [promptsWithAction, scrollContainer]);

  const sectionGridData = useMemo(
    () => ([promptsGridSection]),
    [promptsGridSection]
  );

  return (
    <div className={mergeClasses('explore-prompt', explorePromptsStyles)}>
      <div className="title" role="heading" aria-level="2">
        <span>
          {i18n.getString(_TL_('Explore prompts'))}
        </span>
      </div>
      <SectionTilesGrid
        sectionData={sectionGridData}
        onRenderCell={onRenderCell}
      />
    </div>
  );
});
